import {CountUp} from "countup.js";

export default class Counter {
    constructor($el) {
        this.$el = $el;
        this.value = parseInt(this.$el.dataset.countUp);
        this.countUp = this.countUp.bind(this);

        this.countUp();
    }

    countUp() {
        const options = {
            startVal: 1,
        };
        var countUp = new CountUp(this.$el, this.value, options);
        countUp.start();
    }
}